<template>
	<div class="notification-post">
		<data-container
			title="Notification Posts"
			description="List of all notification posted for upmood."
		>
			<template #controls>
				<custom-option
					:options="['All', 'Posted', 'In Queue']"
					placeholder="Filter by"
					v-model="filters.status"
					@input="getList"
				>
				</custom-option>

				<custom-option
					:options="['latest', 'oldest']"
					placeholder="Sort by"
					v-model="filters.sort"
					@input="getList"
				>
				</custom-option>

				<custom-search
					v-model="filters.keyword"
					placeholder="Search"
					@input="search"
				>
				</custom-search>

				<button
					class="btn-primary"
					@click="$router.push('/notification-post/create')"
				>
					Create
				</button>
			</template>

			<template #content>
				<custom-table
					:fields="fields"
					:items="notifications.data"
					:current-page="filters.page"
					:items-per-page="filters.itemsPerPage"
					:total-count="notifications.total"
					@change-page="changePage($event)"
					:is-loading="notificationLoading"
					:is-selectable="false"
				>
					<template #status="{ item }">
						{{ item.is_sent ? 'Posted' : 'In Queue' }}
					</template>

					<template #created_at="{ item }">
						{{ item.created_at | dateFormatter('MMM DD, YYYY hh:mm A') }}
					</template>

					<template #country="{ item }">
						<span v-if="item.country.length === 0">
							All
						</span>

						<a
							class="clickable"
							v-else
							@click="viewCountry(item.country)"
						>
							View
						</a>
					</template>

					<template #user="{ item }">
						<span v-if="item.users.length === 0">
							All
						</span>

						<a
							class="clickable"
							v-else
							@click="selectViewUser(item)"
						>
							View
						</a>
					</template>

					<template #notification_date="{ item }">
						{{ item.notification_date | dateFormatter('MMM DD, YYYY hh:mm A') }}
					</template>

					<template #actions="{ item }">
						<img
							src="@/assets/icons/ic_edit.svg"
							class="action-icon"
							:class="{ 'disable': item.is_sent || buttonLoading }"
							@click="editItem(item)"
						>

						<img
							src="@/assets/icons/ic_delete.svg"
							class="action-icon"
							:class="{ 'disable':  buttonLoading }"
							@click="deleteItem(item)"
						>
					</template>
				</custom-table>
			</template>
		</data-container>

		<side-panel
			v-if="showCountryPanel"
			@close="toggleCountryPanel(false)"
		>
			<panel-list
				title="Country List"
				description="List of notified Country"
				:items="countries"
				:fields="['name']"
			>
				<template #name="{ item }">
					{{ item }}
				</template>
			</panel-list>

		</side-panel>

		<side-panel
			v-if="showUserPanel"
			@close="toggleUserPanel(false)"
		>
			<panel-list
				title="User List"
				description="list of sent notification"
				:items="userViewList.data"
				:fields="['avatar', 'id', 'name']"
				:is-loading="userViewLoading"
				:from="userViewList.from"
				:to="userViewList.to"
				:total="userViewList.total"
				@prev="changeViewUserPage(-1)"
				@next="changeViewUserPage(1)"
			>
				<template
					#avatar="{ item }"
				>
					<img
						@error="handleImageError"
						:src="item.image || require('@/assets/img/avatar-default.png')"
						class="panel-list-avatar"
					/>
				</template>
			</panel-list>
		</side-panel>

		<modal
			v-if="modalName.includes('delete-notification')"
			@close="$store.dispatch('closeModal')"
		>
			<section class="warning" slot="content">
				<span @click="$store.dispatch('closeModal')" class="close">&#10005;</span>
				<h1>Are you sure?</h1>

				<div class="actions">
					<button @click="$store.dispatch('confirm')" class="btn-primary">Yes</button>
					<button @click="$store.dispatch('closeModal')" class="btn-danger">Cancel</button>
				</div>
			</section>
		</modal>

		<side-notification v-if="bannerStatus"></side-notification>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import * as notificationModule from '@/store/notification'
import NotificationFilter from '@/class/NotificationFilter.js'
import CustomTable from '@/components/utils/CustomTable.vue'
import PanelList from '@/components/layouts/PanelList.vue'
import DataContainer from '@/components/layouts/DataContainer.vue'
import CustomOption from '@/components/utils/CustomOption.vue'
import CustomSearch from '@/components/utils/CustomSearch.vue'
import SidePanel from '@/components/utils/SidePanel.vue'
import Modal from '@/components/utils/Modal.vue'
import SideNotification from '@/components/utils/SideNotification.vue'

export default {
	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['notification/']) {
			this.$store.registerModule('notification', notificationModule.default)
		}
	},

	async created () {
		await this.checkParams()
		this.getList()
	},

	data () {
		return {
			showCountryPanel: false,
			showUserPanel: false,

			countries: [],
			users: [],

			filters: {
				keyword: '',
				page: 1,
				totalCount: 200,
				itemsPerPage: 30,
				filter: '',
				sort: '',
				status: 'All'
			},

			fields: [
				{ name: 'id', text: 'ID' },
				{ name: 'status', text: 'Status' },
				{ name: 'created_at', text: 'Date Created' },
				{ name: 'title', text: 'Post Titile' },
				{ name: 'description', text: 'Notification Description' },
				{ name: 'country', text: 'Country' },
				{ name: 'user', text: 'User' },
				{ name: 'notification_date', text: 'Notification Date' }
			],

			items: [
				{ id: '1', status: 'Posted', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'All', notif_date: 'November 30, 2020 1:00 PM' },
				{ id: '2', status: 'Posted', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'user1, user2, user3', notif_date: 'September 29, 2020 1:00 PM' },
				{ id: '3', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'user2', notif_date: 'September 29, 2020  1:00 PM' },
				{ id: '4', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'All', notif_date: 'September 29, 2020 1:00 PM' },
				{ id: '5', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'All', notif_date: 'September 29, 2020 1:00 PM' },
				{ id: '6', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'All', notif_date: 'September 29, 2020 1:00 PM' },
				{ id: '7', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'All', notif_date: 'September 29, 2020 1:00 PM' },
				{ id: '8', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'All', notif_date: 'September 29, 2020 1:00 PM' },
				{ id: '9', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'user1', notif_date: 'September 29, 2020 1:00 PM' },
				{ id: '10', status: 'In queue', date_created: 'October 25, 2019 10:00 AM', post_title: 'Maintenance', description: 'Upmood will have maintenance on September 29, 2020 for upgrade', country: 'Japan, Hong Kong', sex: 'Male, Female, Other', age: '100-100', user: 'user1, user2, user3', notif_date: 'September 29, 2020  1:00 PM' }
			],

			notifUsers: [
				{ id: 1, avatar: require('@/assets/img/sample.png'), name: 'User 1' },
				{ id: 2, avatar: require('@/assets/img/sample.png'), name: 'User 2' },
				{ id: 3, avatar: require('@/assets/img/sample.png'), name: 'User 3' },
				{ id: 4, avatar: require('@/assets/img/sample.png'), name: 'User 4' },
				{ id: 5, avatar: require('@/assets/img/sample.png'), name: 'User 5' }
			],

			viewUser: {
				page: 1,
				id: 0
			}
		}
	},

	computed: {
		...mapFields('notification', {
			notifications: 'notifications',
			notificationLoading: 'notificationLoading',
			userViewList: 'userViewList',
			userViewLoading: 'userViewLoading',
			buttonLoading: 'buttonLoading'
		}),

		...mapGetters({
			modalName: 'modalName',
			bannerStatus: 'getBannerStatus'
		})
	},

	methods: {

		getList () {
			const { apiQuery, routerQuery } = new NotificationFilter(this.filters)
			this.$store.dispatch('notification/getList', apiQuery)
			this.$router.push({ query: routerQuery })
		},

		async checkParams () {
			const {
				page,
				order_by,
				status,
				count,
				keyword
			} = this.$route.query

			if (page) {
				this.filters.page = parseInt(page)
			}

			if (keyword) {
				this.filters.keyword = keyword
			}

			if (order_by) {
				this.filters.sort = order_by
			}

			if (status) {
				this.filters.status = status === 'queue' ? 'In Queue' : status
			}

			if (count) {
				this.filters.itemsPerPage = parseInt(count)
			}
		},

		async search (e) {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.filters.page = 1
				this.getList()
			}, 500)
		},

		changeViewUserPage (value) {
			this.viewUser.page += value
			this.viewUserList()
		},

		selectViewUser ({ id }) {
			this.viewUser.id = id
			this.viewUser.page = 1
			this.viewUserList()
			this.toggleUserPanel(true)
		},

		viewUserList () {
			const { id, page } = this.viewUser
			const apiQuery = `?id=${id}&page=${page}`
			this.$store.dispatch('notification/viewUser', apiQuery)
		},

		viewCountry (countries) {
			this.countries = countries
			this.toggleCountryPanel(true)
		},

		editItem ({ id, notification_date }) {
			const { filters } = this.$options
			const isPostDate = filters.isPostDate(new Date(notification_date))

			if (!isPostDate) {
				this.$router.push(`notification-post/edit/${id}`)
				return
			}

			this.$store.dispatch('toggleBanner', {
				status: true,
				message: 'Notification cannot be edited.',
				type: 'invalid'
			})
		},

		deleteItem ({ id }) {
			let { apiQuery } = new NotificationFilter(this.filters)
			apiQuery += `&id=${id}`
			this.$store.commit('toggleModal', {
				modalName: 'delete-notification',
				confirm: () => {
					this.$store.dispatch('notification/delete', apiQuery)
					this.$store.dispatch('closeModal')
				}
			})
		},

		changePage ({ currentPage, itemsPerPage }) {
			if (this.filters.page === currentPage) {
				this.filters.page = 1
			} else {
				this.filters.page = currentPage
			}

			this.filters.itemsPerPage = itemsPerPage
			this.getList()
		},

		toggleCountryPanel (status) {
			this.showCountryPanel = status
		},

		toggleUserPanel (status) {
			// this.viewUser.page = 1
			// this.viewUser.id = 0
			this.showUserPanel = status
		},

		handleImageError (event) {
			event.target.src = require('@/assets/img/avatar-default.png')
		}
	},

	components: {
		CustomTable,
		DataContainer,
		CustomOption,
		CustomSearch,
		SidePanel,
		PanelList,
		Modal,
		SideNotification
	}
}
</script>

<style lang="scss" scoped>
.notification-post {
	.action-icon {
		width: 25px;
		margin-left: 10px;
		padding: 2px;
		border: 2px solid transparent;
		border-radius: 5px;
		cursor: pointer;

		&.disable {
			pointer-events: none;
			filter: grayscale(1);
			border-color: $light;
		}
	}

	/deep/ .custom-table {
		th,
		td {
			&:nth-child(5) {
				width: 300px;
			}

			&:nth-child(1),
			&:nth-child(2) {
				width: 100px;
			}
		}
	}

	.clickable {
		color: $primary;
	}

	.panel-list-avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}
}
</style>
